<template>
  <div>
    <img src="@/assets/tarjeta_ofertas_seguro_mascotas.jpg" style="width: 100%" />
    <p class="tituloTarjeta">TU MASCOTA PROTEGIDA DESDE 30€ AL AÑO</p>
    <p>
      Te protegemos a ti y a tu mascota de los daños que pueda ocasionar a terceros con nuestro Seguro de Mascotas.
    </p>
    <ul style="list-style-type: disc">
      <li>Responsabilidad civil.</li>
      <li>Defensa de reclamaciones.</li>
      <li>Veterinario urgencia 24h.</li>
      <li>Asistencia veterinario telefónico.</li>
    </ul>
    <p>
      ¡La vida es mejor con tu mascota protegida!
    </p>
   
    <p class="container-flex">
      <a href="https://www.mmtseguros.com/calcular/seguros-mascotas" target="_blank">
        <button class="pure-button botonLlamar">Calcula tu precio</button>
      </a>
    </p>

  </div>
</template>

<script>
/* eslint-disable no-console */
export default {
 
};
</script>

<style lang="scss" scoped>
.container-flex {
  margin-top: 2.5rem;
  display: flex;
  flex-direction: row;
  justify-content: space-around;
}

.botonLlamar {
  background-color: $colorMMT;
  color: white;
  font-weight: bold;
  width: 13rem;
  border: 0.15rem solid;
  text-align: center;
  border-radius: 0.5rem;
}

// .container-flex a:first-child {
//   margin-right: 15%;
// }
</style>
